export const getNonceValue = () => {
  return ""
}
